import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as selectors from '../application.selectors';

const Button = (props) => {
  const {onClick, disabled, children, className, size, busy, style} = props;
  return (
    <button onClick={onClick} disabled={disabled || busy} className={`btn-${size} ${className}`} style={style}>
      {/*{busy && <React.Fragment><i className="glyphicon glyphicon-refresh"/>&nbsp;</React.Fragment>}*/}
      {children}
    </button>
  );
};

Button.defaultProps = {
  size: 'md',
  onClick: () => {
  }
};

Button.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  busy: PropTypes.bool,
};

const BusyButton = connect(
  state => ({busy: selectors.fetchingData(state)})
)(Button);

export const DefaultButton = ({className, ...rest}) =>
  <BusyButton className={`${className} btn btn-default`} {...rest} />;

export const PrimaryButton = ({className, ...rest}) =>
  <BusyButton className={`${className} btn btn-primary`} {...rest} />;

export const WarningButton = ({className, ...rest}) =>
  <BusyButton className={`${className} btn btn-warning`} {...rest} />;

export const DangerButton = ({className, ...rest}) =>
  <BusyButton className={`${className} btn btn-danger`} {...rest} />;

export const SuccessButton = ({className, ...rest}) =>
  <BusyButton className={`${className} btn btn-success`} {...rest} />;

PrimaryButton.propTypes = Button.propTypes;
WarningButton.propTypes = Button.propTypes;
DangerButton.propTypes = Button.propTypes;
SuccessButton.propTypes = Button.propTypes;
DefaultButton.propTypes = Button.propTypes;



// WEBPACK FOOTER //
// ./src/components/Button.js